import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { useTheme } from '@mui/material';

const Chip = styled.div`
 text-transform: uppercase;
 background-color: ${props => props.$bgColor ? props.$bgColor : props.theme.colors.primaryFaint};
 color: ${props => props.$color ? props.$color : props.theme.colors.primary};
 font-weight: 500;
 height: fit-content;
 padding: .2rem 1rem;
 border-radius: 2px;
 width: fit-content;
 text-transform: ${props => props.$uc ? "uppercase" : "none"};

 ${props => props.$size === "small" && css/* closed */`
    font-size: 1.2rem;
    padding: .1rem .6rem;
 `}

 ${props => props.$size === "large" && css/* closed */`
    font-size: 1.6rem;
    padding: .4rem 1rem;
 `}

 ${props => props.$style && css/* closed */`
    ${props.$style}
 `}


 @media ${props => props.theme.breaks.down('md')} {
  /* width: min-content; */
 }
`;

const SimpleChip = ({ label, color, bgColor, uc, size = "medium", palette = "classic", style }) => {
  const theme = useTheme();
  const paletteColors = {
    ...theme.palette,
    classic: {
      light: theme.colors.darkBg,
      main: theme.colors.text.muted
    },
    // primary: {
    //   light: theme.colors.primaryFaint,
    //   main: theme.colors.primary
    // }
  }
  let { light, main } = paletteColors[palette];
  color = color ? color : main;
  bgColor = bgColor ? bgColor : light;
  return ( label &&
    <Chip $bgColor={bgColor} $color={color} $uc={uc} $size={size} $style={style}>
      {label}
    </Chip>
  )
};

export default SimpleChip;